import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { MFormation } from '@argalis-apps/models';

@Component({
  selector: 'ags-formation',
  templateUrl: './formation.component.html',
  styleUrls: ['./formation.component.scss']
})
export class FormationComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}
  public listOfSession = false;
  public sessionPage = false;
  public notFoundPage = false;
  public choosedFormation: any;
  public idFormation: number;
  public formationEmitter = new EventEmitter();
  

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['id'] === 'list') {
        this.listOfSession = true;
        this.sessionPage = false;
        this.notFoundPage = false;
      } else if (params['id'] !== void 0) {
        this.sessionPage = true;
        this.listOfSession = false;
        this.notFoundPage = false;
        this.idFormation = params['id'];
      } else {
        this.sessionPage = false;
        this.listOfSession = false;
        this.notFoundPage = true;
      }
    });
  }

  selectedFormation(event: any) {
    this.choosedFormation = event;
    this.listOfSession = false;
    this.idFormation = event.id;
  }
}
